import { COMPANY_SCREENER, COMPANY_SEARCH, ERROR, NOT_FOUND } from '@/lib/constants/route-names'
import { ACCOUNT_PROFILE, LOGOUT, LOGIN_CALLBACK } from '@/lib/constants/auth-routes'

import Account from '@/views/auth/Account'
import Home from '@/views/Home'
import Companies from '@/views/Companies'
import WatchlistsListView from '@/views/WatchlistsListView'
import WatchlistView from '@/views/WatchlistView'
import CreateReport from '@/views/CreateReport'
import Error from '@/views/Error'
import NotFound from '@/views/404'
import ReportsListView from '@/views/ReportsListView'
import ArenaListView from '@/views/ArenaListView'
import ArenaOutputView from '@/views/ArenaOutputView'
import ArenaView from '@/views/ArenaView'
import CreatePlaybook from '@/views/CreatePlaybook'
import Research from '@/views/Research'
import LoginCallback from '@/views/auth/LoginCallback.vue'
import { authGuard } from '@auth0/auth0-vue'
import CompanySearch from '@/views/CompanySearch.vue'
import CompanyScreener from '@/views/CompanyScreener.vue'
import PatentSearch from '@/views/PatentSearch.vue'
import PatentView from '@/views/PatentView.vue'

export const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        props: { initTab: '1' },
        beforeEnter: authGuard,
        meta: { tabName: 'Home' },
    },
    {
        path: '/companies',
        name: 'Companies',
        component: Companies,
        beforeEnter: authGuard,
        redirect: { name: COMPANY_SCREENER },
        children: [
            {
                path: 'search',
                name: COMPANY_SEARCH,
                component: CompanySearch,
            },
            {
                path: 'screener/:screenerId?',
                name: COMPANY_SCREENER,
                component: CompanyScreener,
            },
        ],
    },
    {
        path: '/research-company/:targetPk',
        name: 'Research Company',
        component: Research,
        meta: { requiresAuth: true },
        query: { tabName: null },
        beforeEnter: authGuard,
    },
    {
        path: '/research-patent/:patentId',
        name: 'Research Patent',
        component: PatentView,
        meta: { requiresAuth: true },
        beforeEnter: authGuard,
    },
    {
        path: '/watchlist-list',
        name: 'Watchlist List',
        component: WatchlistsListView,
        beforeEnter: authGuard,
        meta: { tabName: 'Watchlist List' },
    },
    {
        path: '/create-report',
        name: 'Create Report',
        component: CreateReport,
        beforeEnter: authGuard,
        query: { reportPk: null, watchlistPk: null, source: null },
        meta: { tabName: 'Create Report' },
    },
    {
        path: '/watchlist/:datasetPk',
        name: 'Watchlist',
        component: WatchlistView,
        beforeEnter: authGuard,
        meta: { tabName: 'Watchlist' },
    },
    {
        path: '/playbooks',
        name: 'Playbooks',
        component: CreatePlaybook,
        beforeEnter: authGuard,
        meta: { tabName: 'Playbooks' },
    },
    {
        path: '/patent-search/:seedString?',
        name: 'Patent Search',
        component: PatentSearch,
        beforeEnter: authGuard,
        meta: { tabName: 'Patent Search' },
    },
    {
        path: '/error',
        name: ERROR,
        component: Error,
        meta: { fullScreen: true },
    },
    {
        path: '/loginCallback',
        name: LOGIN_CALLBACK,
        component: LoginCallback,
    },
    {
        path: '/logout',
        name: LOGOUT,
    },
    {
        path: '/account',
        name: ACCOUNT_PROFILE,
        component: Account,
        beforeEnter: authGuard,
    },
    {
        path: '/404',
        name: NOT_FOUND,
        component: NotFound,
        meta: { fullScreen: true },
    },
    {
        path: '/reports',
        name: 'Reports',
        component: ReportsListView,
        meta: { requiresAuth: true, tabName: 'Reports List' },
    },
    {
        path: '/arena/:arenaSourceId?',
        name: 'Arena',
        component: ArenaView,
        meta: { requiresAuth: true, tabName: 'Arena' },
    },
    {
        path: '/arenas',
        name: 'Arena List View',
        component: ArenaListView,
        meta: { requiresAuth: true, tabName: 'Arena List' },
    },
    {
        path: '/arenaOutput/:jobPk?',
        name: 'Arena Output',
        component: ArenaOutputView,
        meta: { requiresAuth: true, tabName: 'Arena Output' },
    },
    {
        // Keep the catchAll route last
        path: '/:pathMatch(.*)*',
        redirect: { name: 'Not Found' },
    },
]
